// Confere os dígitos; a consulta de dados cadastrais é um recurso separado.
export const registrationDocumentError = (value, required = false) => {
  if (value === undefined || value === null || value === '' || (typeof value === 'string' && !value.trim())) {
    return required ? 'CPF ou CNPJ é obrigatório' : '';
  }
  if (typeof value !== 'string' || value.length > 32 || !/^[\d.\/\s-]+$/.test(value)) return 'Informe um CPF ou CNPJ válido';
  const document = value.replace(/\D/g, '');
  if (document.length !== 11 && document.length !== 14) return 'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos';
  const invalid = document.length === 11 ? 'CPF inválido' : 'CNPJ inválido: confira os dígitos informados';
  if (/^(\d)\1+$/.test(document)) return invalid;
  const cpf = document.length === 11;
  for (let position = cpf ? 9 : 12; position < document.length; position++) {
    let sum = 0;
    for (let index = 0; index < position; index++) {
      sum += Number(document[index]) * (cpf ? position + 1 - index : ((position - 1 - index) % 8) + 2);
    }
    const remainder = sum % 11;
    if (Number(document[position]) !== (remainder < 2 ? 0 : 11 - remainder)) return invalid;
  }
  return '';
};
